import { render, staticRenderFns } from "./LimitProductCustomerGroup.vue?vue&type=template&id=d6a165e6&scoped=true&"
import script from "./LimitProductCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./LimitProductCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./LimitProductCustomerGroup.vue?vue&type=style&index=0&id=d6a165e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a165e6",
  null
  
)

export default component.exports